// lbl.consent_register
export const consent_register = {
    page_title: "ข้อตกลงการใช้งาน",
    accept: "ยอมรับ",
}